import React, { useState } from "react";
import { Pagination } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

const CustomPagination = ({ totalPages = 5, totalRecord = 0 ,size = "sm", withIcons = true, disablePrev = false, loading = false, onPageChange }) => {
  const [activeItem, setActiveItem] = useState(1);

  const onPrevItem = () => {
    if (!loading) {
        setActiveItem((prev) => {
            const newPage = prev === 1 ? prev : prev - 1;
            onPageChange(newPage); // Pass updated page
            return newPage;
        });
    }
  };

  const onNextItem = () => {
    if (!loading) {
        setActiveItem((prev) => {
            const newPage = prev === totalPages ? prev : prev + 1;
            onPageChange(newPage); // Pass updated page
            return newPage;
        });
    }
  };

  // if(totalPages == 0 || totalRecord == 0){
  //   return null;
  // }

  return (
    <div className="d-flex justify-content-center mt-3"> {/* Centers pagination */}
      <Pagination size={size} className="pagination">
        {/* Previous Button */}
        <Pagination.Prev disabled={loading || disablePrev || activeItem === 1} onClick={onPrevItem}>
          {withIcons ? <FontAwesomeIcon icon={faAngleDoubleLeft} /> : "Previous"}
        </Pagination.Prev>

        {/* First Page & Ellipsis */}
        {totalPages > 6 && activeItem > 4 && (
          <>
            <Pagination.Item disabled={loading} onClick={() => {setActiveItem(1);onPageChange(1);}}>1</Pagination.Item>
            <Pagination.Ellipsis disabled />
          </>
        )}

        {/* Page Numbers */}
        {Array.from({ length: totalPages }, (_, i) => i + 1)
          .filter((number) => {
            if (totalPages <= 6) return true;
            if (activeItem < 4) return number <= 5;
            if (activeItem > totalPages - 3) return number >= totalPages - 4;
            return Math.abs(number - activeItem) < 3;
          })
          .map((number) => (
            <Pagination.Item
              key={number}
              active={activeItem === number}
              disabled={loading}
              onClick={() => {setActiveItem(number);onPageChange(number);}}
            >
              {number}
            </Pagination.Item>
          ))}

        {/* Ellipsis & Last Page */}
        {totalPages > 6 && activeItem < totalPages - 3 && (
          <>
            <Pagination.Ellipsis disabled />
            <Pagination.Item disabled={loading} onClick={() => {setActiveItem(totalPages);onPageChange(totalPages);}}>
              {totalPages}
            </Pagination.Item>
          </>
        )}

        {/* Next Button */}
        <Pagination.Next disabled={loading || activeItem === totalPages || totalPages == 0} onClick={onNextItem}>
          {withIcons ? <FontAwesomeIcon icon={faAngleDoubleRight} /> : "Next"}
        </Pagination.Next>
      </Pagination>
    </div>
  );
};

export default CustomPagination;
